"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_EXCLUDE_DONATION_PROVIDERS_CORPORATE_DONATION = exports.DEFAULT_APPLICATION_FEE_CORPORATE = exports.DEFAULT_APPLICATION_FEE_EMPLOYEE = exports.DEFAULT_CORPORATE_DONATION_FEE_CAP_USD = exports.DEFAULT_PROVIDER_FEE_CAP_USD = exports.DEFAULT_DEED_FEE_CAP_USD = exports.MAXIMUM_DONATION_LOCAL_CURRENCY_LIMIT_STRIPE = exports.MAXIMUM_DONATION_USD_LIMIT = exports.MAXIMUM_DONATION_USD_LIMIT_GIVEINDIA = exports.MAXIMUM_DONATION_USD_LIMIT_PAY_PAL = void 0;
const enums_1 = require("./types/enums");
exports.MAXIMUM_DONATION_USD_LIMIT_PAY_PAL = 200000;
exports.MAXIMUM_DONATION_USD_LIMIT_GIVEINDIA = 999999;
exports.MAXIMUM_DONATION_USD_LIMIT = 9999;
exports.MAXIMUM_DONATION_LOCAL_CURRENCY_LIMIT_STRIPE = 999999; // @NOTE-AT: The Stripe donation has notional amount limit of 6
exports.DEFAULT_DEED_FEE_CAP_USD = 250;
exports.DEFAULT_PROVIDER_FEE_CAP_USD = 250;
exports.DEFAULT_CORPORATE_DONATION_FEE_CAP_USD = 1000;
exports.DEFAULT_APPLICATION_FEE_EMPLOYEE = 2.5;
exports.DEFAULT_APPLICATION_FEE_CORPORATE = 2.5;
exports.DEFAULT_EXCLUDE_DONATION_PROVIDERS_CORPORATE_DONATION = [
    enums_1.DonationProvider.Betterplace,
    enums_1.DonationProvider.Stripe,
    enums_1.DonationProvider.GiveIndia,
    enums_1.DonationProvider.External,
];
//# sourceMappingURL=constants.js.map